import { whiteColor, shadowColor, lightgray } from 'theme/color';

export const statusCard = () => ({
  background: whiteColor,
  boxShadow: 'none',
  border: '1px solid rgba(17, 35, 71, 0.1)',
  borderRadius: '5px',
  padding: '20px',
  marginBottom: '30px',
  marginTop: '30px',
  '.MuiGrid-root': {
    flexGrow: '1',
  },
});

export const moreInfoContainer = {
  marginTop: '10px',
  padding: '8px 14px',
  borderRadius: '8px',
  background: lightgray,
};
export const checkboxcolor = {
  background: 'rgba(196, 196, 196, 0.22)',
};

export const switchStyle = () => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: '2px',
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        background:
          'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 20,
    height: 20,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
  },
});

export const highStarStyle = {
  width: '16px',
  height: '16px',
};

export const highManageStarStyle = {
  width: '16px',
  height: '16px',
  paddingBottom: '5px',
};
